var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotesimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3407 1.2542V1.3542H15.4407H17.546C18.8661 1.3542 19.94 2.42807 19.94 3.74817V20.506C19.94 21.8261 18.8661 22.9 17.546 22.9H2.49397C1.17386 22.9 0.1 21.8261 0.1 20.506V3.74817C0.1 2.42807 1.17386 1.3542 2.49397 1.3542H4.59928H4.69928V1.2542V0.821429C4.69928 0.423026 5.0223 0.1 5.42071 0.1C5.81911 0.1 6.14214 0.423026 6.14214 0.821429V1.2542V1.3542H6.24214H9.19856H9.29856V1.2542V0.821429C9.29856 0.423026 9.62158 0.1 10.02 0.1C10.4184 0.1 10.7414 0.423026 10.7414 0.821429V1.2542V1.3542H10.8414H13.7978H13.8978V1.2542V0.821429C13.8978 0.423026 14.2209 0.1 14.6193 0.1C15.0177 0.1 15.3407 0.423026 15.3407 0.821429V1.2542ZM4.69928 2.89706V2.79706H4.59928H2.49397C1.96946 2.79706 1.54286 3.22367 1.54286 3.74817V20.506C1.54286 21.0305 1.96946 21.4571 2.49397 21.4571H17.546C18.0705 21.4571 18.4971 21.0305 18.4971 20.506V3.74817C18.4971 3.22367 18.0705 2.79706 17.546 2.79706H15.4407H15.3407V2.89706V3.33024C15.3407 3.72864 15.0177 4.05166 14.6193 4.05166C14.2209 4.05166 13.8978 3.72864 13.8978 3.33024V2.89706V2.79706H13.7978H10.8414H10.7414V2.89706V3.33024C10.7414 3.72864 10.4184 4.05166 10.02 4.05166C9.62158 4.05166 9.29856 3.72864 9.29856 3.33024V2.89706V2.79706H9.19856H6.24214H6.14214V2.89706V3.33024C6.14214 3.72864 5.81911 4.05166 5.42071 4.05166C5.0223 4.05166 4.69928 3.72864 4.69928 3.33024V2.89706Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83901 12.0316H14.2009C14.5993 12.0316 14.9223 12.3547 14.9223 12.7531C14.9223 13.1515 14.5993 13.4745 14.2009 13.4745H5.83901C5.4406 13.4745 5.11758 13.1515 5.11758 12.7531C5.11758 12.3547 5.4406 12.0316 5.83901 12.0316Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83901 16.2152H14.2009C14.5993 16.2152 14.9223 16.5383 14.9223 16.9367C14.9223 17.3351 14.5993 17.6581 14.2009 17.6581H5.83901C5.4406 17.6581 5.11758 17.3351 5.11758 16.9367C5.11758 16.5383 5.4406 16.2152 5.83901 16.2152Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18368 9.29481H5.83901C5.4406 9.29481 5.11758 8.97178 5.11758 8.57338C5.11758 8.17498 5.4406 7.85195 5.83901 7.85195H9.18368C9.58208 7.85195 9.90511 8.17498 9.90511 8.57338C9.90511 8.97178 9.58208 9.29481 9.18368 9.29481Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesimg);
export default __webpack_public_path__ + "static/media/notesimg.4df41ac2a600aa0dcc3a19d1bb709873.svg";
export { ForwardRef as ReactComponent };